import React from 'react'

export interface RouteContextValue {
  baseRoute: string
}

export const getRouteValue = (route: string): string => {
  let routeValue: string

  // Base route is /partners/directory from A20M
  if (!route.includes('/partners/directory')) {
    routeValue = '/partners/directory'
  } // Base route is /{locale}/partners/directory from A20M
  else {
    const regex = /.+?(?=\/partners\/directory)/
    const regexValue = regex.exec(route)
    routeValue = (regexValue ? regexValue[0] : '') + '/partners/directory'
  }
  return routeValue
}

export const RouteContext = React.createContext({ baseRoute: '/partners/directory' })
